import { cn } from '@/lib/utils'

interface SkeletonProps {
  /** 너비 (Tailwind 클래스 또는 CSS) */
  width?: string
  /** 높이 (Tailwind 클래스 또는 CSS) */
  height?: string
  /** 원형 여부 */
  rounded?: boolean
  /** 추가 CSS 클래스 */
  className?: string
}

/**
 * 스켈레톤 로딩 컴포넌트.
 * 데이터 로딩 중 콘텐츠 자리 표시자 역할을 합니다.
 */
export default function Skeleton({
  width,
  height,
  rounded = false,
  className,
}: SkeletonProps) {
  return (
    <div
      role="status"
      aria-label="콘텐츠 로딩 중"
      className={cn(
        'animate-pulse bg-cb-gray-200',
        rounded ? 'rounded-full' : 'rounded-[var(--radius-input)]',
        className
      )}
      style={{
        width: width ?? '100%',
        height: height ?? '1rem',
      }}
    >
      <span className="sr-only">로딩 중...</span>
    </div>
  )
}
